const { formatMoney } = window.BAO.Utils

const selectors = {
  price: '[data-product-price]',
  productCardPrice: '[data-product-card-price]',
}

class ProductPrice extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.igCheck()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(window, 'ig:ready', this.igCheck.bind(this))
  }

  igCheck () {
    const price = window.igData?.price?.getPriceByVariantId(this.dataset.id)
    if (!price) return

    this.setPrices()
  }

  setPrices () {
    const price = window.igData?.price?.getPriceByVariantId(this.dataset.id)
    const comparePrice = window.igData?.price?.getComparePriceByVariantId(
      this.dataset.id,
    )

    const priceEl =
      this.closest(selectors.price) || this.closest(selectors.productCardPrice)

    if (comparePrice) {
      priceEl.innerHTML = `
      <span class="prd-Price_SalePrice">
        ${formatMoney(price * 100)}
      </span>

      <s class="prd-Price_RegularPrice">
        ${formatMoney(comparePrice * 100)}
      </s>`
    } else {
      priceEl.innerHTML = `${formatMoney(price * 100)}`
    }
  }
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice)
}
